module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('h2', [_vm._v("Profile")]), _vm._v(" "), _c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tab', {
    attrs: {
      "href": "#profile-tab"
    }
  }, [_vm._v("\n            Profile\n          ")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#courses-tab"
    }
  }, [_vm._v("\n            Courses\n          ")]), _vm._v(" "), _c('v-tab', {
    attrs: {
      "href": "#stats-tab"
    }
  }, [_vm._v("\n            Stats\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tabs-items', [_c('v-tab-item', {
    attrs: {
      "id": "profile-tab"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.userData) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Name")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.userData.name) + "\n                      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Email")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.userData.email) + "\n                      ")])], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Phone")])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs9": "",
      "md10": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.userData.phone) + "\n                      ")])], 1)], 1), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('vendor')) ? _c('v-flex', {
    attrs: {
      "mt-2": "",
      "ml-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "tag": "h4",
      "mb-5": ""
    }
  }, [_vm._v("\n                        Products\n                      ")]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.productsList,
      "hide-actions": "",
      "hide-headers": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.price))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.category.name))])]
      }
    }], null, false, 808808980)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('case-manager')) ? _c('v-flex', {
    attrs: {
      "mt-2": "",
      "ml-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "tag": "h4",
      "mb-5": ""
    }
  }, [_vm._v("\n                        Commissions (total for now $" + _vm._s(_vm.totalCommission) + ")\n                      ")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.casesList), function(workCase, i) {
    return _c('v-flex', {
      key: i,
      attrs: {
        "mb-5": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "tag": "b"
      }
    }, [_vm._v("\n                        Case ID # " + _vm._s(workCase.id) + "\n                      ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": "",
        "mt-3": ""
      }
    }, [_c('v-data-table', {
      attrs: {
        "items": workCase.products,
        "headers": _vm.productsTableHeaders,
        "hide-actions": ""
      },
      scopedSlots: _vm._u([{
        key: "items",
        fn: function(props) {
          return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(props.item.commission))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_updated))])]
        }
      }], null, true)
    }, [_vm._v(" "), _c('template', {
      slot: "footer"
    }, [_c('v-flex', {
      attrs: {
        "mt-5": "",
        "ml-3": ""
      }
    }, [_c('b', [_vm._v("Total commission for case:")]), _vm._v(" $" + _vm._s(_vm.calculcateCaseCommission(workCase.id)) + "\n                            ")])], 1)], 2)], 1)], 1)
  })], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.refresh()
      }
    }
  }, [_vm._v("\n                    Hard Refresh\n                  ")])], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "courses-tab"
    }
  }, [(_vm.userData) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "md2": ""
    }
  }, [_c('h5', [_c('b', [_vm._v("Edx Completion Percent")])])])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.courses,
      "headers": _vm.coursesTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.course_id.replace(/\+/g, " ")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s((Number(props.item.earned_all / props.item.possible_all).toFixed(2) * 100).toFixed(0)))])]
      }
    }], null, false, 3122296579)
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    attrs: {
      "id": "stats-tab"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.statData) ? _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [(_vm.$store.getters.currentUserRoles.includes('dispatcher') || _vm.$store.getters.currentUserRoles.includes('management')) ? _c('div', {
    staticClass: "stat-lead-row",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', [_c('h5', [_c('b', [_vm._v("Total leads by month:")])])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "leadsTable"
  }, _vm._l((_vm.leadsData), function(leadItem, index) {
    return _c('div', {
      staticClass: "leadsTable__item"
    }, [_c('div', {
      staticClass: "leadsTable__item__month"
    }, [_vm._v(_vm._s(leadItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "leadsTable__item__count"
    }, [_vm._v(_vm._s(leadItem.value))])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('case-manager')) ? _c('div', {
    staticClass: "stat-lead-row",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', [_c('h5', [_c('b', [_vm._v("Your cases:")])])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "leadsTable"
  }, _vm._l((_vm.casesData), function(caseItem, index) {
    return _c('div', {
      staticClass: "leadsTable__item"
    }, [_c('div', {
      staticClass: "leadsTable__item__month"
    }, [_vm._v(_vm._s(caseItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "leadsTable__item__count"
    }, [_vm._v(_vm._s(caseItem.value))])])
  }), 0)])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters.currentUserRoles.includes('case-crew')) ? _c('div', {
    staticClass: "stat-lead-row",
    attrs: {
      "ripple": ""
    }
  }, [_c('v-flex', [_c('h5', [_c('b', [_vm._v("Participating in cases:")])])]), _vm._v(" "), _c('v-flex', [_c('div', {
    staticClass: "leadsTable"
  }, _vm._l((_vm.partiCasessData), function(leadItem, index) {
    return _c('div', {
      staticClass: "leadsTable__item"
    }, [_c('div', {
      staticClass: "leadsTable__item__month"
    }, [_vm._v(_vm._s(leadItem.name))]), _vm._v(" "), _c('div', {
      staticClass: "leadsTable__item__count"
    }, [_vm._v(_vm._s(leadItem.value))])])
  }), 0)])], 1) : _vm._e()]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d97aa5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 958
// module chunks = 1